export default "__VITE_ASSET__BNlAHWwy__"